var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#0088F5",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#check_svg__clip0_782_14006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.75 52.951L60.88 28.82l3.714 3.712L36.75 60.375 20.045 43.669l3.712-3.711L36.75 52.95z",
    fill: "#D4D4D8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "check_svg__clip0_782_14006"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10.5 13.125)",
    d: "M0 0h63v63H0z"
  })))));
}
export default SvgCheck;